import { render } from "./TargetCreate.vue?vue&type=template&id=529acd65&scoped=true"
import script from "./TargetCreate.vue?vue&type=script&lang=js"
export * from "./TargetCreate.vue?vue&type=script&lang=js"

import "./TargetCreate.vue?vue&type=style&index=0&id=529acd65&scoped=true&lang=css"

import exportComponent from "/Users/avinduhewa/Documents/Projects/bokaklip/payl-firebase/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529acd65"]])

export default __exports__